import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../api";

// Cache redirects in memory after first fetch
let cache = null;
let promise = null;

async function loadRedirects() {
  if (cache) return cache;
  if (!promise) {
    promise = api.get("/redirects").then((r) => { cache = r.data || []; return cache; }).catch(() => { cache = []; return cache; });
  }
  return promise;
}

export default function RedirectHandler() {
  const loc = useLocation();
  const nav = useNavigate();
  useEffect(() => {
    (async () => {
      const list = await loadRedirects();
      const hit = list.find((r) => r.from === loc.pathname);
      if (hit && hit.to && hit.to !== loc.pathname) {
        if (hit.to.startsWith("http")) { window.location.href = hit.to; }
        else nav(hit.to, { replace: true });
      }
    })();
  }, [loc.pathname, nav]);
  return null;
}
